import apiClient from '@/config/api/axios'
import { AUTH_LOGIN } from '@/config/api/endpoints'
import { isAuthDevBypass } from '@/config/api/env'
import { createDevAuthSession } from './devAuthSession.js'
import { normalizeLoginResponse } from './normalizeLoginResponse.js'

export async function loginWithEmailPassword({ email, password }) {
  if (isAuthDevBypass()) return createDevAuthSession(email)
  const { data } = await apiClient.post(AUTH_LOGIN, { email, password }, { timeout: 30_000 })
  return normalizeLoginResponse(data)
}
